// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__1fW8d","overlay":"Dialog_overlay__DyrmR","content":"Dialog_content__LsGU6","close":"Dialog_close__B6SHk","icon":"Dialog_icon__vevlE"};